import React from "react";
import PropTypes from "prop-types";

function CloseIcon({ color }) {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_24_2)">
				<path d="M0.706591 16.9703C0.519054 16.7828 0.413697 16.5285 0.413697 16.2632C0.413697 15.998 0.519054 15.7437 0.706591 15.5561L15.5558 0.706893C15.7434 0.519357 15.9977 0.414 16.2629 0.414C16.5282 0.414 16.7825 0.519357 16.97 0.706893C17.1576 0.89443 17.2629 1.14878 17.2629 1.414C17.2629 1.67922 17.1576 1.93357 16.97 2.12111L2.1208 16.9703C1.93327 17.1579 1.67891 17.2632 1.4137 17.2632C1.14848 17.2632 0.894127 17.1579 0.706591 16.9703V16.9703Z" fill={color}/>
				<path d="M0.706562 0.707659C0.894098 0.520122 1.14845 0.414765 1.41367 0.414765C1.67888 0.414765 1.93324 0.520122 2.12078 0.707659L16.97 15.5569C17.1576 15.7444 17.2629 15.9988 17.2629 16.264C17.2629 16.5292 17.1576 16.7836 16.97 16.9711C16.7825 17.1587 16.5281 17.264 16.2629 17.264C15.9977 17.264 15.7433 17.1587 15.5558 16.9711L0.706562 2.12187C0.519025 1.93434 0.413668 1.67998 0.413668 1.41476C0.413668 1.14955 0.519025 0.895195 0.706562 0.707659V0.707659Z" fill={color}/>
			</g>
			<defs>
				<clipPath id="clip0_24_2">
					<rect width="17.678" height="17.678" fill="white"/>
				</clipPath>
			</defs>
		</svg>

	);
}

CloseIcon.propTypes = {
	color: PropTypes.string
};

export default CloseIcon;